import React from 'react';
import {
  CreateAccount,
  ForgotPassword,
  SignIn,
  TermsAndConditions,
  NoAuthContractPage,
} from '~/scenes';
import { Stack } from '../stackNavigation';

export const AuthNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_SignIn"
      component={SignIn}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="MarisaServicos_CreateAccount"
      component={CreateAccount}
      options={{ headerShown: false }}
    />

    <Stack.Screen
      name="MarisaServicos_ForgotPassword"
      component={ForgotPassword}
      options={{ headerShown: false }}
    />

    <Stack.Screen
      name="MarisaServicos_TermsAndConditions"
      component={TermsAndConditions}
      options={{ headerShown: false }}
    />

    <Stack.Screen
      name="MarisaServicos_NoAuthContractPage"
      component={NoAuthContractPage}
    />
  </Stack.Group>
);
